import MetaTag from '../../layout/MetaTag';
import Navbar from '../HomeScreen/Navbar'
import SearchItems from './SearchItems'
import Footer from '../HomeScreen/bottomsection/Footer'

import './search.css'


function SearchScreen() {
    return (
        <>
            <MetaTag
                title="Search Shoes Online | IM Online Shop"
                description="Search sneakers, sports shoes, loafers, boots, and new arrivals at IM Online Shop."
                keywords="search shoes online, sneakers search, sports shoes, loafers, boots, IM Online Shop"
            />
            <Navbar />
            <main className="search-main-container-div">
                <section className="search-hero-panel">
                    <div className="search-hero-copy">
                        <span>Find your next pair</span>
                        <h1>Search IM Online Shop</h1>
                        <p>Look up sneakers, sports shoes, boots, loafers, brands, and trending pairs in one place.</p>
                    </div>
                    <SearchItems />
                </section>
            </main>
            <Footer />
        </>
    )
}

export default SearchScreen
